import React, { useEffect } from 'react';
import styles from './styles.module.scss';

export default function TailwindModal({
  children,
  isVisible,
  onClose,
  size = 'medium',
  className = '',
}) {
  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isVisible]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isVisible) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  const sizeClasses = {
    small: 'max-w-md',
    medium: 'max-w-lg',
    large: 'max-w-2xl',
    xlarge: 'max-w-4xl',
    full: 'max-w-full mx-4',
  };

  const heightClasses = {
    small: 'h-auto max-h-[300px]',
    medium: 'h-auto max-h-[600px]',
    large: 'h-auto max-h-[700px]',
    xlarge: 'h-auto max-h-[90vh]',
    full: 'h-auto max-h-[90vh]',
  };

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${styles.modalOverlay}`}
      onClick={onClose}
    >
      <div
        className={`relative w-full ${sizeClasses[size]} ${heightClasses[size]} bg-white rounded-2xl shadow-2xl overflow-hidden ${styles.modalContent} ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-50 w-8 h-8 flex items-center justify-center rounded-full bg-white/90 hover:bg-white text-slate-400 hover:text-slate-600 transition-all duration-200 shadow-md hover:shadow-lg"
          aria-label="Close modal"
        >
          <i className="fas fa-times text-sm"></i>
        </button>
        {children}
      </div>
    </div>
  );
}

